import { AVAILABLE_LANGUAGES } from '$locale/constants';

export const MAX_BREADCRUMBS_SIZE = 3;

export const TOAST_ERROR_TIME = 5000;

export const MILISECONDS_IN_A_DAY = 86400000;

export const FORCE_MAJEURE_MAX_ITEMS_TO_SHOW = 2;

export const DASHBOARD_URL: { [key: string]: string } = {
  'user-profile': 'profile',
  verification: 'verification',
  manageAccount: 'manageAccount',
  home: 'home',
  'request-correction': 'requestCorrection'
};

export const webGlobalMockState = {
  screen: {
    isMobile: false
  },
  locale: {
    lang: AVAILABLE_LANGUAGES.en
  }
};

export const mobileGlobalMockState = {
  screen: {
    isMobile: true
  },
  locale: {
    lang: AVAILABLE_LANGUAGES.en
  }
};

export const VERIFICATION_LIST_PAGE_SIZE = 25;

export const NOT_AVAILABLE = 'N/A';
